import { render, staticRenderFns } from "./cardsMobile.vue?vue&type=template&id=18b73104&scoped=true"
import script from "./cardsMobile.vue?vue&type=script&lang=js"
export * from "./cardsMobile.vue?vue&type=script&lang=js"
import style0 from "./cardsMobile.vue?vue&type=style&index=0&id=18b73104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b73104",
  null
  
)

export default component.exports